<template>
  <div class="default-avatar">
    <figure>
      <img class="rounded-circle" :src="currentAvatar" alt="avatar" />
    </figure>
  </div>
</template>

<script>
import axios from 'axios';
import { errorService } from '../../services/errorService';
export default {
  props: { candidate_id: String },
  data: () => ({
    currentAvatar: '',
    getUrl: '',
  }),
  methods: {
    getAvatar() {
      axios
        .get(`${process.env.VUE_APP_API_URL}${this.getUrl}${this.candidate_id}`, {
          responseType: `blob`,
          headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(response => {
          const blob = new Blob([response.data], { type: 'image/*' });
          const fileUrl = URL.createObjectURL(blob);
          this.currentAvatar = fileUrl;
        })
        .catch(err => {
          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
  },
  mounted() {
    if (localStorage.getItem('acc') === 'admin') {
      this.getUrl = '/admin/candidate/avatar/';
    } else if (localStorage.getItem('acc') === 'manager') {
      this.getUrl = '/manager/candidates/getavatar/';
    }
    this.getAvatar();
  },
};
</script>
<style lang="scss" scoped>
.default-avatar {
  position: absolute;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .overlay {
    cursor: pointer;
    position: absolute;
    display: flex;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    font-size: 21px;
    background: rgba(0, 0, 0, 0.4);
    color: #fff;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.125);
    opacity: 0;
    -webkit-transition: all 200ms ease;
    -moz-transition: all 200ms ease;
    -ms-transition: all 200ms ease;
    -o-transition: all 200ms ease;
    transition: all 200ms ease;
  }
  &:hover {
    .overlay {
      opacity: 1;
    }
  }
}
.temporary-avatar {
  width: 160px;
  height: 160px;
  border-radius: 50%;
  object-fit: cover;
}
</style>
